import React, { useState, useRef, useEffect } from 'react';
import api from './api/client';
import * as XLSX from 'xlsx';
import HeaderLogged from './components/header_logged';
import DataTable from './components/DataTable';
import Container from './components/container';
import Tabs from './components/Tabs';
import TableTittle from './components/TableTittle';
import SearchAndFilter from './components/SearchAndFilter';
import Icons from './components/icons';
import Popup from './components/Popup';
import SubMenu from './components/Submenu';
import AddForm from './components/AddForm';
import { API_URL } from './config';
import DataTableWithExpandableRows from './components/DataTableWithExpandableRows';
import SecondaryTable from './components/SecondaryTable';
import UniversalDataTable from './components/UniversalDataTable';
import FlexibleSecondaryTable from './components/FlexibleSecondaryTable';
import SeedsActionPopup from './components/SeedsActionPopup';

const InventoryMaterialsPage = () => {
  // Конфигурация фильтров для каждого таба
  const filtersConfig = {
    seedslocationwh: [],
    smallbagsinventory: [],
    masterbagsinventory: [],
    wildmicrmasterbagsinventory: [],
    fert_masterbag_stock: [],
    fert_bag_stock: [],
    minitoolsinventory: [],
    silicagelinventory: [],
  };

  // Инициализация состояния для хранения текущих значений фильтров
  const [filterParams, setFilterParams] = useState(() => {
    const initialFilters = {};
    for (const tab in filtersConfig) {
      filtersConfig[tab].forEach(filter => {
        if (filter.defaultValue) {
          initialFilters[filter.field] = filter.defaultValue;
        }
      });
    }
    return initialFilters;
  });

  const setDefaultFilters = () => {
    const defaultFilters = {};
    if (Array.isArray(filtersConfig[activeTab])) {
      filtersConfig[activeTab].forEach(filter => {
        if (filter.defaultValue) {
          defaultFilters[filter.field] = filter.defaultValue;
        }
      });
    }
    setFilterParams(defaultFilters);
  };

  useEffect(() => {
    setDefaultFilters();
  }, []);

  const [searchTerm, setSearchTerm] = useState('');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [popupFields, setPopupFields] = useState([]);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupSubtitle, setPopupSubtitle] = useState('');
  const [updateKey, setUpdateKey] = useState(0);
  const [activeTab, setActiveTab] = useState('seedslocationwh');
  const [data, setData] = useState([]);
  const tableRefs = useRef({});
  const [isSeedsActionPopupOpen, setIsSeedsActionPopupOpen] = useState(false);
  const [seedsActionData, setSeedsActionData] = useState(null);

  const keyFieldsConfig = {
    sets: 'SKU',
    brands: 'brandID',
    containers: 'containerID',
    seeds: 'seedsID',
    setscomposition: ['setSKU', 'sbSKU'],
    seedscategory: 'categoryID',
    employees: 'employeeID',
    emplphones: 'employeeID',
    empladdresses: 'employeeID',
    individualpackets: 'SKU',
    sbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
    mbproduction: ['sku', 'emplID', 'prodDate', 'boxnum'],
    whlocations: 'location',
    seedslocationwh: ['seedsID', 'bagnumid'],
    masterbagsinventory: 'sku',
    smallbagsinventory: 'sku',
    individualpacketsinventory: 'SKU',
    setsInventory: 'SKU',
    wildmicr: 'SKU',
    wmseedsinventory: 'seedsID',
    wildmicrinventory: 'SKU',
    wildmicrproduction: ['SKU', 'emplID', 'prodDate', 'boxnum'],
    wildmicrmasterbagsinventory: 'sku',
    minitoolsinventory: 'brandID',
    silicagelinventory: 'brandID',
    shipmentsfbamb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
    shipmentsfbafb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
    shipmentssbss: ['brandID', 'SKU', 'shipmentDate'],
    shipmentsssmb: ['brand Greenwood Seeds', 'SKU', 'shipmentDate'],
    shipmentswildmicrss: ['brandID', 'SKU', 'shipmentDate'],
    shipmentswildmicrfba: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
    workperformance: ['employeeID', 'workday', 'shift'],
    materialsuppliers: ['supplierID'],
    seedssuppliers: ['supplierID'],
    smallbagsorder: ['sku', 'orderDate'],
    masterbagsorder: ['sku', 'orderDate'],
    seedsorders: ['seedsID', 'supplierID', 'orderdate'],
    silicabagsorders: ['brandID', 'orderDate'],
    toolsorders: ['brandID', 'orderDate'],
    wmmasterbagsorder: ['sku', 'orderDate'],
    smallbagsinventory_log: ['logID'],
    masterbagshistory: ['id'],
    wmmasterbagsinventory_history: ['id'],
    fert_masterbag_stock: 'SKU',
    fert_bag_stock: ['rawMaterialID', 'bagNumber'],
  };

  const handleSearch = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const handleFilter = (params) => {
    setFilterParams(params);
    fetchTabData(`${API_URL}/api/${activeTab}`, params);
  };

  const handleEdit = (data, id) => {
    const tableName = activeTab;
    const fields = tabs.find(tab => tab.name === tableName).fields.map(field => {
      const fieldValue = data[field.name];
      if (field.name === 'germtestdate' && fieldValue) {
        return {
          ...field,
          value: toLocalDateString(fieldValue),
        };
      }
      return {
        ...field,
        value: fieldValue,
      };
    });

    const keyFields = keyFieldsConfig[tableName];
    const initialKeyValues = Array.isArray(keyFields)
      ? keyFields.reduce((acc, key) => {
          acc[key] = data[key];
          return acc;
        }, {})
      : { [keyFields]: data[keyFields] };

    setPopupData({ ...data, tableName, id, initialKeyValues });
    setPopupFields(fields);
    setPopupTitle(`Edit ${tableName}`);
    setPopupSubtitle(`Edit ${tableName} details`);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setPopupData(null);
    setPopupFields([]);
    setUpdateKey(prevKey => prevKey + 1);
  };

  const handlePopupSubmit = async (event) => {
    event.preventDefault();
    try {
      const updateData = popupFields.reduce((acc, field) => {
        acc[field.name] = field.value;
        return acc;
      }, {});

      const tableName = popupData.tableName;
      const keyFields = keyFieldsConfig[tableName];
      const isEditMode = !!popupData.id;

      let url;
      let method;
      let currentKeys;

      if (isEditMode) {
        currentKeys = popupData.initialKeyValues;
        if (Array.isArray(keyFields)) {
          const id = keyFields.map(key => `${key}=${currentKeys[key]}`).join('&');
          url = `/api/${tableName}?${id}&currentKeys=${encodeURIComponent(JSON.stringify(currentKeys))}`;
          method = 'put';
        } else {
          const id = currentKeys[keyFields];
          url = `/api/${tableName}/${id}?currentKeys=${encodeURIComponent(JSON.stringify(currentKeys))}`;
          method = 'put';
        }
      } else {
        url = `/api/${tableName}`;
        method = 'post';
      }

      console.log(`Sending ${method.toUpperCase()} request to: ${url}`);
      console.log('Update data:', updateData);

      const response = await api({
        method,
        url,
        data: updateData,
      });

      console.log('Server response:', response.data);
      handleClosePopup();
      setUpdateKey(prevKey => prevKey + 1);
    } catch (error) {
      console.error(`Error data:`, error);
      if (error.response) {
        console.error('Server responded with:', error.response.data);
      }
    }
  };

  const handleFieldChange = (index, event) => {
    const newFields = [...popupFields];
    newFields[index].value = event.target.value;
    const updatedData = { ...popupData, [newFields[index].name]: event.target.value };
    setPopupFields(newFields);
    setPopupData(updatedData);
  };

  const handleAddClick = () => {
    const fields = tabs.find(tab => tab.name === activeTab).fields.map(field => ({
      ...field,
      value: '',
    }));
    setPopupData({ tableName: activeTab });
    setPopupFields(fields);
    setPopupTitle(`Add New ${activeTab}`);
    setPopupSubtitle(`Add new ${activeTab} details`);
    setIsPopupOpen(true);
  };

  const handleAddSubmit = async (event) => {
    event.preventDefault();
    try {
      const newData = popupFields.reduce((acc, field) => {
        acc[field.name] = field.value;
        return acc;
      }, {});

      const tableName = popupData.tableName;
      console.log('handleAddSubmit newData:', newData);
      const response = await api.post(`/api/${tableName}`, newData);
      console.log('Server response:', response.data);
      handleClosePopup();
      setUpdateKey(prevKey => prevKey + 1);
    } catch (error) {
      console.error('Error adding data:', error);
      if (error.response) {
        console.error('Server responded with:', error.response.data);
      }
    }
  };

  const handleSeedsActionClick = async (row) => {
    let actionType = null;
    let existingData = null;

    console.log('BagStatus:', row.BagStatus);
    console.log('Row Data:', row);

    const bagStatusLower = row.BagStatus.toLowerCase();

    if (bagStatusLower === 'in treatment') {
      actionType = 'treatment';
      try {
        const response = await api.get('/api/seeds_treatment/latest', {
          params: { seedsID: row.seedsID, bagNumber: row.bagnumid },
        });
        console.log('Seeds Treatment API Response:', response.data);
        existingData = response.data;
      } catch (error) {
        console.error('Error fetching treatment data:', error);
      }
    } else if (bagStatusLower === 'under germination test') {
      actionType = 'germination';
      try {
        const response = await api.get('/api/seedsgermination/latest', {
          params: { seedsID: row.seedsID, bagNumber: row.bagnumid },
        });
        console.log('Seeds Germination API Response:', response.data);
        existingData = response.data;
      } catch (error) {
        console.error('Error fetching germination data:', error);
      }
    }

    console.log('Setting seedsActionData:', {
      seedsID: row.seedsID,
      bagNumber: row.bagnumid,
      seedsName: row.combinedSeedsName,
      actionType,
      existingData,
    });

    setSeedsActionData({
      seedsID: row.seedsID,
      bagNumber: row.bagnumid,
      seedsName: row.combinedSeedsName || 'Unknown Seed',
      actionType,
      existingData,
    });
    setIsSeedsActionPopupOpen(true);
  };

  const handleSeedsActionSubmit = async (data, endpoint) => {
    console.log('Submitting to endpoint:', endpoint);
    console.log('Data to submit:', data);
    try {
      if (data.id) {
        await api.put(endpoint, {
          ...(data.returnedWeight && { returnedWeight: parseFloat(data.returnedWeight) }),
          ...(data.germinationPercentage && { germinationPercentage: parseFloat(data.germinationPercentage) }),
        });
      } else {
        const payload = {
          seedsID: data.seedsID,
          bagNumber: data.bagNumber,
          ...(data.actionType === 'treatment' && {
            Weight: parseFloat(data.weight),
            StartDateTime: data.startDateTime,
            InfestationRate: data.infestationRate,
            Room: data.room,
          }),
          ...(data.actionType === 'germination' && {
            Weight: parseFloat(data.weight),
            StartDate: data.startDate,
          }),
        };
        console.log('POST payload:', payload);
        await api.post(endpoint, payload);
      }
      setIsSeedsActionPopupOpen(false);
      setSeedsActionData(null);
      await fetchTabData(`${API_URL}/api/${activeTab}`);
      if (activeTab === 'seedslocationwh') {
        const response = await api.get('/api/seedslocationwhdetails', {
          params: {
            seedsID: data.seedsID,
            bagnumid: data.bagNumber,
          },
        });
        console.log('Secondary table data after submit:', response.data);
      }
      setUpdateKey(prev => prev + 1);
    } catch (error) {
      console.error('Error submitting seed action:', error);
      if (error.response) {
        console.error('Server response:', error.response.data);
      }
    }
  };

  useEffect(() => {
    if (!isPopupOpen && !isSeedsActionPopupOpen) {
      fetchTabData(`${API_URL}/api/${activeTab}`);
    }
  }, [isPopupOpen, isSeedsActionPopupOpen, activeTab]);

  const handleSeedsActionClose = () => {
    setIsSeedsActionPopupOpen(false);
    setSeedsActionData(null);
  };

  function toLocalDateString(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const fetchTabData = async (endpoint) => {
    try {
      const response = await api.get(endpoint, {
        params: {
          page: 1,
          limit: 100,
          search: searchTerm,
          ...filterParams,
        },
      });
      console.log('Fetched Data:', response.data);
      setData(response.data.items);
    } catch (error) {
      console.error('Error fetching tab data:', error);
    }
  };

  useEffect(() => {
    if (!isPopupOpen && !isSeedsActionPopupOpen) {
      fetchTabData(`${API_URL}/api/${activeTab}`);
    }
  }, [isPopupOpen, isSeedsActionPopupOpen]);

  const menuItems = [
    { name: 'Materials', link: '/inventory-materials' },
    { name: 'Products', link: '/inventory-products' },
  ];

  const tabs = [
    {
      name: 'seedslocationwh',
      label: 'Seeds',
      fields: [
        {
          label: 'Seeds ID',
          name: 'seedsID',
          type: 'select',
          tableName: 'seeds',
          displayField: 'combinedSeedsName',
          updateField: 'seedsID',
        },
        { label: 'Bag', name: 'bagnumid', type: 'text' },
        {
          label: 'Container',
          name: 'containerID',
          type: 'select',
          tableName: 'containers',
          displayField: 'containerName',
          updateField: 'containerID',
        },
        { label: 'Lot', name: 'lot', type: 'text' },
        { label: 'Weight', name: 'currentWeight', type: 'text' },
        { label: 'Germ.Rate', name: 'germtestrate', type: 'text' },
        { label: 'Test Date', name: 'germtestdate', type: 'date' },
      ],
      content: (
        <DataTableWithExpandableRows
          columns={[
            { key: 'seedsID', label: 'ID' },
            { key: 'combinedSeedsName', label: 'Seeds' },
            { key: 'bagnumids', label: 'Bag' },
            { key: 'containerNames', label: 'Container' },
            { key: 'lots', label: 'Lot' },
            { key: 'totalWeight', label: 'Weight' },
            { key: 'earliestGermtestDate', label: 'Earliest Test Date' },
            { key: 'latestGermtestDate', label: 'Latest Test Date' },
            { key: 'rateRange', label: 'Germ Rate' },
            {
              key: 'seedsforbags',
              label: 'Can be produced',
              type: 'dropdown',
              endpoint: `${API_URL}/api/seeds-production-options`,
            },
            { key: 'lastModified', label: 'Last Modified' },
          ]}
          endpoint={`${API_URL}/api/seedslocationwh`}
          secondaryTableConfig={{
            endpointBase: `${API_URL}/api/seedslocationwhdetails`,
            columns: [
              { key: 'bagnumid', label: 'Bag ID' },
              { key: 'lot', label: 'Lot' },
              { key: 'containerName', label: 'Bag/Container' },
              { key: 'currentWeight', label: 'Weight' },
              { key: 'germtestdate', label: 'Germ Test Date' },
              { key: 'germtestrate', label: 'Germination Rate' },
              { key: 'BagStatus', label: 'Status' },
            ],
            enableEdit: true,
            enableHistory: true,
            enableSeedAction: true,
            keyFieldsConfig: ['seedsID', 'bagnumid'],
            historyConfig: {
              endpoint: `${API_URL}/api/seedslocationwh/history`,
              columns: [
                { key: 'modifiedAt', label: 'Date/Time', type: 'datetime' },
                { key: 'modifiedBy', label: 'Modified By' },
                { key: 'oldWeight', label: 'Old Weight' },
                { key: 'newWeight', label: 'New Weight' },
              ],
            },
            onSeedAction: handleSeedsActionClick,
            updateKey: updateKey,
          }}
          keyFieldsConfig={['seedsID', 'bagnumid']}
          onEdit={handleEdit}
          searchTerm={searchTerm}
          filterParams={filterParams}
          updateKey={updateKey}
        />
      ),
    },
    {
      name: 'fert_bag_stock',
      label: 'Fertilizer Bulk Stock',
      fields: [
        {
          label: 'Fertilizer Type',
          name: 'rawMaterialID',
          type: 'select',
          tableName: 'fert_raw_materials',
          displayField: 'materialName',
          updateField: 'id',
        },
        { label: 'Bag Number', name: 'bagNumber', type: 'text' },
        {
          label: 'Container',
          name: 'containerID',
          type: 'select',
          tableName: 'containers',
          displayField: 'containerName',
          updateField: 'containerID',
        },
        { label: 'Supplier Lot', name: 'lotSupplier', type: 'text' },
        { label: 'Expiration Date', name: 'expirationDate', type: 'date' },
        { label: 'Weight (lb)', name: 'currentWeightLb', type: 'text' },
      ],
      content: (
        <DataTableWithExpandableRows
          columns={[
            { key: 'rawMaterialID',  label: 'ID' },
            { key: 'materialName',   label: 'Fertilizer Type' },
            { key: 'bag_count',      label: 'Bags' },
            { key: 'total_weight',   label: 'Total Weight (lb)' },
            {
              key: 'canProduce',
              label: 'Can Be Produced',
              type: 'dropdown',
              endpoint: `${API_URL}/api/fert_bag_stock_production_options`,
              paramKey: 'rawMaterialID',
            },
            { key: 'first_added',   label: 'First Added' },
            { key: 'last_modified', label: 'Last Modified' },
          ]}
          endpoint={`${API_URL}/api/fert_bag_stock`}
          secondaryTableConfig={{
            title: 'Bags',
            endpointBase: `${API_URL}/api/fert_bag_stockdetails`,
            columns: [
              { key: 'bagNumber',       label: 'Bag Number' },
              { key: 'lotSupplier',     label: 'Supplier Lot' },
              { key: 'expirationDate',  label: 'Exp. Date' },
              { key: 'containerName',   label: 'Container' },
              { key: 'currentWeightLb', label: 'Weight (lb)' },
              { key: 'createdAt',       label: 'Added', type: 'datetime' },
            ],
            enableEdit: true,
            enableHistory: true,
            keyFieldsConfig: ['rawMaterialID', 'bagNumber'],
            historyConfig: {
              endpoint: `${API_URL}/api/fert_bag_stock_history`,
              columns: [
                { key: 'changedAt',    label: 'Date/Time', type: 'datetime' },
                { key: 'changedBy',    label: 'Changed By' },
                { key: 'weightBefore', label: 'Weight Before' },
                { key: 'weightAfter',  label: 'Weight After' },
                { key: 'weightDiff',   label: 'Difference' },
                { key: 'source',       label: 'Source' },
              ],
            },
            updateKey: updateKey,
          }}
          keyFieldsConfig={['rawMaterialID', 'bagNumber']}
          onEdit={handleEdit}
          searchTerm={searchTerm}
          filterParams={filterParams}
          updateKey={updateKey}
        />
      ),
    },
    {
      name: 'smallbagsinventory',
      label: 'Small Packets',
      fields: [
        {
          label: 'Brand',
          name: 'brandID',
          type: 'select',
          tableName: 'brands',
          displayField: 'brandName',
          updateField: 'brandID',
        },
        {
          label: 'Name',
          name: 'sku',
          type: 'select',
          tableName: 'individualpackets',
          displayField: 'packName',
          updateField: 'SKU',
        },
        { label: 'Current QTY', name: 'currentQTY', type: 'text' },
        { label: 'WH Lot', name: 'locationWH', type: 'text' },
      ],
      content: (
        <UniversalDataTable
          columns={[
            { label: 'Brand', key: 'brandID' },
            { label: 'SKU', key: 'sku' },
            { label: 'Model Number', key: 'modelNumber' },
            { label: 'Name', key: 'packName' },
            { label: 'Current QTY', key: 'currentQTY' },
            { label: 'WH Lot', key: 'locationWH' },
          ]}
          endpoint={`${API_URL}/api/smallbagsinventory`}
          secondaryTableConfig={{
            endpointBase: `${API_URL}/api/smallbagsinventory_log`,
            columns: [
              { key: 'logID', label: 'ID' },
              { key: 'sku', label: 'SKU' },
              { key: 'old_qty', label: 'Old QTY' },
              { key: 'new_qty', label: 'New QTY' },
              { key: 'changed_by', label: 'Changed By' },
              { key: 'change_datetime', label: 'Date', type: 'datetime' },
              { key: 'change_source', label: 'Source' },
              { key: 'recID', label: 'Production Record ID' },
            ],
            enableEdit: false,
            enableDelete: false,
            enableHistory: false,
          }}
          keyFieldsConfig={keyFieldsConfig}
          tableName="smallbagsinventory"
          onEdit={handleEdit}
          searchTerm={searchTerm}
          filterParams={filterParams}
          enableEdit={true}
          enableDelete={true}
          updateKey={updateKey}
        />
      ),
    },
    {
      name: 'masterbagsinventory',
      label: 'Master Bags',
      fields: [
        {
          label: 'Name',
          name: 'sku',
          type: 'select',
          tableName: 'sets',
          displayField: 'setmane',
          updateField: 'SKU',
        },
        { label: 'Current QTY', name: 'currentQTY', type: 'text' },
        { label: 'WH Lot', name: 'locationWH', type: 'text' },
      ],
      content: (
        <UniversalDataTable
          columns={[
            { label: 'SKU', key: 'sku' },
            { label: 'Name', key: 'setmane' },
            { label: 'Current QTY', key: 'currentQTY' },
            { label: 'WH Lot', key: 'locationWH' },
          ]}
          endpoint={`${API_URL}/api/masterbagsinventory`}
          secondaryTableConfig={{
            endpointBase: `${API_URL}/api/masterbagshistory`,
            columns: [
              { key: 'id', label: 'ID' },
              { key: 'sku', label: 'SKU' },
              { key: 'oldQty', label: 'Old QTY' },
              { key: 'newQty', label: 'New QTY' },
              { key: 'difference', label: 'Difference' },
              { key: 'changedBy', label: 'Changed By' },
              { key: 'dateChanged', label: 'Date', type: 'datetime' },
              { key: 'source', label: 'Source' },
              { key: 'boxnumChanged', label: 'Production Box Number' },
            ],
            enableEdit: false,
            enableDelete: false,
            enableHistory: false,
          }}
          keyFieldsConfig={keyFieldsConfig}
          tableName="masterbagsinventory"
          onEdit={handleEdit}
          searchTerm={searchTerm}
          filterParams={filterParams}
          enableEdit={true}
          enableDelete={true}
          updateKey={updateKey}
        />
      ),
    },
    {
      name: 'wildmicrmasterbagsinventory',
      label: 'Microgreens & Wildflower Bags',
      fields: [
        {
          label: 'Name',
          name: 'sku',
          type: 'select',
          tableName: 'wildmicr',
          displayField: 'packName',
          updateField: 'SKU',
        },
        { label: 'Current QTY', name: 'currentQTY', type: 'text' },
        { label: 'WH Lot', name: 'locationWH', type: 'text' },
      ],
      content: (
        <UniversalDataTable
          columns={[
            { label: 'SKU', key: 'sku' },
            { label: 'Name', key: 'packName' },
            { label: 'Current QTY', key: 'currentQTY' },
            { label: 'WH Lot', key: 'locationWH' },
          ]}
          endpoint={`${API_URL}/api/wildmicrmasterbagsinventory`}
          secondaryTableConfig={{
            endpointBase: `${API_URL}/api/wmmasterbagsinventory_history`,
            columns: [
              { key: 'id', label: 'ID' },
              { key: 'sku', label: 'SKU' },
              { key: 'oldQty', label: 'Old QTY' },
              { key: 'newQty', label: 'New QTY' },
              { key: 'difference', label: 'Difference' },
              { key: 'changedBy', label: 'Changed By' },
              { key: 'dateChanged', label: 'Date', type: 'datetime' },
              { key: 'source', label: 'Source' },
              { key: 'boxnumChanged', label: 'Production Box Number' },
            ],
            enableEdit: false,
            enableDelete: false,
            enableHistory: false,
          }}
          keyFieldsConfig={keyFieldsConfig}
          tableName="wildmicrmasterbagsinventory"
          onEdit={handleEdit}
          searchTerm={searchTerm}
          filterParams={filterParams}
          enableEdit={true}
          enableDelete={true}
          updateKey={updateKey}
        />
      ),
    },
    {
      name: 'fert_masterbag_stock',
      label: 'Fertilizer Master Bags',
      fields: [
        {
          label: 'Product',
          name: 'SKU',
          type: 'select',
          tableName: 'fert_products',
          displayField: 'productName',
          updateField: 'SKU',
        },
        { label: 'Current QTY', name: 'quantity', type: 'text' },
      ],
      content: (
        <UniversalDataTable
          columns={[
            { label: 'SKU', key: 'SKU' },
            { label: 'Product Name', key: 'productName' },
            { label: 'Current QTY', key: 'quantity' },
          ]}
          endpoint={`${API_URL}/api/fert_masterbag_stock`}
          secondaryTableConfig={{
            endpointBase: `${API_URL}/api/fert_masterbag_stock_history`,
            columns: [
              { key: 'id',         label: 'ID' },
              { key: 'SKU',        label: 'SKU' },
              { key: 'qtyBefore',  label: 'Before' },
              { key: 'qtyAfter',   label: 'After' },
              { key: 'qtyDiff',    label: 'Difference' },
              { key: 'changedBy',  label: 'Changed By' },
              { key: 'changedAt',  label: 'Date', type: 'datetime' },
              { key: 'source',     label: 'Source' },
            ],
            enableEdit: false,
            enableDelete: false,
            enableHistory: false,
          }}
          keyFieldsConfig={keyFieldsConfig}
          tableName="fert_masterbag_stock"
          onEdit={handleEdit}
          searchTerm={searchTerm}
          filterParams={filterParams}
          enableEdit={true}
          enableDelete={true}
          updateKey={updateKey}
        />
      ),
    },

    {
      name: 'minitoolsinventory',
      label: 'Mini Garden Tools',
      fields: [
        {
          label: 'Brand',
          name: 'brandID',
          type: 'select',
          tableName: 'brands',
          displayField: 'brandName',
          updateField: 'brandID',
        },
        { label: 'Current QTY', name: 'QTY', type: 'text' },
        { label: 'WH Lot', name: 'location', type: 'text' },
      ],
      content: (
        <DataTable
          key={updateKey}
          title=""
          columns={[
            { label: 'Brand', key: 'brandName' },
            { label: 'Current QTY', key: 'QTY' },
            { label: 'WH Lot', key: 'location' },
          ]}
          endpoint={`${API_URL}/api/minitoolsinventory`}
          searchTerm={searchTerm}
          filterParams={filterParams}
          onEdit={(data) =>
            handleEdit(
              data,
              `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`
            )
          }
          keyFieldsConfig={keyFieldsConfig}
          onFetchData={fetchTabData}
        />
      ),
    },
    {
      name: 'silicagelinventory',
      label: 'Silicagel Bags',
      fields: [
        {
          label: 'Brand',
          name: 'brandID',
          type: 'select',
          tableName: 'brands',
          displayField: 'brandName',
          updateField: 'brandID',
        },
        { label: 'Current QTY', name: 'QTY', type: 'text' },
        { label: 'WH Lot', name: 'location', type: 'text' },
      ],
      content: (
        <DataTable
          key={updateKey}
          title=""
          columns={[
            { label: 'Brand', key: 'brandName' },
            { label: 'Current QTY', key: 'QTY' },
            { label: 'WH Lot', key: 'location' },
          ]}
          endpoint={`${API_URL}/api/silicagelinventory`}
          searchTerm={searchTerm}
          filterParams={filterParams}
          onEdit={(data) =>
            handleEdit(
              data,
              `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`
            )
          }
          keyFieldsConfig={keyFieldsConfig}
          onFetchData={fetchTabData}
        />
      ),
    },
  ];

  return (
    <>
      <Icons />
      <HeaderLogged />
      <Container>
        <TableTittle
          sectionTitle="Inventory Materials"
          sectionSubtitle="Manage inventory details"
          onAddClick={handleAddClick}
          activeTab={activeTab}
          tableRefs={tableRefs}
        />
        <SearchAndFilter
          placeholder="Search by date, employee name, seeds..."
          onSearch={handleSearch}
          onFilter={handleFilter}
          filtersConfig={filtersConfig[activeTab] || []}
        />
        <Tabs
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tableRefs={tableRefs}
        />
      </Container>
      {popupData && (
        <Popup
          isOpen={isPopupOpen}
          onClose={handleClosePopup}
          title={popupTitle}
          subtitle={popupSubtitle}
          fields={popupFields}
          onFieldChange={handleFieldChange}
          onSubmit={handlePopupSubmit}
        />
      )}
      {seedsActionData && (
        <SeedsActionPopup
          isOpen={isSeedsActionPopupOpen}
          onClose={handleSeedsActionClose}
          onSubmit={handleSeedsActionSubmit}
          seedsName={seedsActionData.seedsName}
          bagNumber={seedsActionData.bagNumber}
          seedsID={seedsActionData.seedsID}
          actionType={seedsActionData.actionType}
          existingData={seedsActionData.existingData}
        />
      )}
    </>
  );
};

export default InventoryMaterialsPage;